import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../app.constants';
import { ResponseContentType } from '../../../../node_modules/@angular/http';
import { BehaviorSubject } from '../../../../node_modules/rxjs';

@Injectable()
export class AssessmentsService {

  public static shouldIDisplayProfileReviewBeh = new BehaviorSubject<boolean>(false);
  public static shouldIDisplayProfileReviewObs = AssessmentsService.shouldIDisplayProfileReviewBeh.asObservable();

  public static refreshSidebarExclamationIconBeh = new BehaviorSubject<boolean>(true);
  public static refreshSidebarExclamationIconObs = AssessmentsService.refreshSidebarExclamationIconBeh.asObservable();

  constructor(private _http: HttpClient, private config: Configuration) { }

  public getProfileDraft() {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/getProfileDraft`, null).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public associateSubmittedProfileReview() {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/associateSubmittedProfileReview`, null).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public saveProfileDraft(draftData) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/saveProfileDraft`, {draftData: draftData}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public isAssessmentsOn() {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/isAssessmentOn`, null).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public toggleAssessmentStatus(status, assessId) {
    return new Promise((ok, notOk) => {
      // tslint:disable-next-line:max-line-length
      this._http.post(`${this.config.ServerApiUrl}/assessments/toggleAssessmentStatus`, {status: status, assessId: assessId}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public getAssessHistoryIds(assocId) {
    return new Promise((ok, notOk) => {
      // tslint:disable-next-line:max-line-length
      this._http.post(`${this.config.ServerApiUrl}/assessments/getAssessHistoryIds`, { assocId: assocId}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public getAssocsToAssess(filters) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/getAssocsToAssess`, filters).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public getEditAssessmentAssocs(filters) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/getEditAssessmentAssocs`, filters).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public getAssocsToReview(filters) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/getAssocsToReview`, filters).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public addNewAssessmentSession(filters) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/addNewAssessmentSession`, filters).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public getNineBoxData(filters) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/getNineBoxData`, filters).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public getReportingHubData(filters) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/getReportingHubData`, filters).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public getFlag(country) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/getFlag`, {country: country}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public getAssessQuestions(assocId, assessId = null) {
    return new Promise((ok, notOk) => {
      // tslint:disable-next-line:max-line-length
      this._http.post(`${this.config.ServerApiUrl}/assessments/getAssessQuestions`, {assocId: assocId, assessId: assessId}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public changeHighPotential(assocId, highPotential) {
    return new Promise((ok, notOk) => {
      // tslint:disable-next-line:max-line-length
      this._http.post(`${this.config.ServerApiUrl}/assessments/changeHighPotential`, {assocId: assocId, highPotential: highPotential}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public shouldIDisplayProfileReview() {
    return new Promise((ok, notOk) => {
      // tslint:disable-next-line:max-line-length
      this._http.post(`${this.config.ServerApiUrl}/assessments/shouldIDisplayProfileReview`, {}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public printVisualization(assocId, assessYear = null) {
    return new Promise((ok, notOk) => {
      // tslint:disable-next-line:max-line-length
      this._http.post(`${this.config.ServerApiUrl}/assessments/printVisualization`, {assocId: assocId, assessYear: assessYear}, {responseType: 'blob'}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public printPlans(assocId, assessYear = null) {
    return new Promise((ok, notOk) => {
      // tslint:disable-next-line:max-line-length
      this._http.post(`${this.config.ServerApiUrl}/assessments/printPlans`, {assocId: assocId, assessYear: assessYear}, {responseType: 'blob'}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public getAssessQuestionsPublic(assocId, assessYear = null) {
    return new Promise((ok, notOk) => {
      // tslint:disable-next-line:max-line-length
      this._http.post(`${this.config.ServerApiUrl}/assessments/getAssessQuestionsPublic`, {assocId: assocId, assessId: assessYear}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public getVisualizationData(assocId, assessYear = null) {
    return new Promise((ok, notOk) => {
      // tslint:disable-next-line:max-line-length
      this._http.post(`${this.config.ServerApiUrl}/assessments/getVisualizationData`, {assocId: assocId, assessYear: assessYear}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public getVisualizationDataPublic(assocId, assessYear = null) {
    return new Promise((ok, notOk) => {
      // tslint:disable-next-line:max-line-length
      this._http.post(`${this.config.ServerApiUrl}/assessments/getVisualizationDataPublic`, {assocId: assocId, assessYear: assessYear}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public getAssociates() {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/getAssociates`, {}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public savePlans(assocId, development, successor, saveType) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/savePlans`, {
        assocId: assocId,
        development: development,
        successor: successor,
        saveType: saveType
      }).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public validateAssessment(assocId, validateType, saveType, remarks = '') {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/validateAssessment`, {
        assocId: assocId,
        validateType: validateType,
        saveType: saveType,
        remarks: remarks
      }).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public saveAssessments(assocId, talent, digital, skill, saveType) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/saveAssessments`, {
        assocId: assocId,
        talent: talent,
        digital: digital,
        skill: skill,
        saveType: saveType
      }).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public saveLeadership(assocId, leadership, potential, performance, comments, saveType) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/saveLeadership`, {
        assocId: assocId,
        leadership: leadership,
        potential: potential,
        performance: performance,
        comments: comments,
        saveType: saveType
      }).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public saveCalibration(leadership, successor, development, potential, performance, comments, saveType, assessPersonId) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/saveCalibration`, {
        leadership: leadership,
        potential: potential,
        performance: performance,
        comments: comments,
        saveType: saveType,
        successor: successor,
        development: development,
        assessPersonId: assessPersonId
      }).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public getAssessedAssociate() {
    return new Promise((ok, notOk) => {
      this._http.get(`${this.config.ServerApiUrl}/assessments/getAssessedAssociate`)
      .subscribe(values => {
      })});
    }

  public saveReview(assocId, talent, digital, skill, saveType, assessType) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/assessments/saveAssessmentsReview`, {
        assocId: assocId,
        talent: talent,
        digital: digital,
        skill: skill,
        saveType: saveType,
        assessType: assessType
      }).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

}
